function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDeleteRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 27h2V12h-2v15zm5 0h2V12h-2v15zm5 0h2V12h-2v15zM6 28.174C6 29.183 6.896 30 8 30h16c1.104 0 2-.817 2-1.826V9H6v19.174zM19 5a3 3 0 10-6 0H4v2h24V5h-9z",
    fill: props.color
  }));
}

export default SvgIconDeleteRexFilled;